import { Injectable } from '@angular/core';
import {  Response, Headers } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { Subject } from 'rxjs/Subject';
import { VcaAlertsService } from '../../../common/vca-alerts';
import { ReplaySubject } from 'rxjs/ReplaySubject';
import 'rxjs/add/operator/map';
import { HttpUtils } from 'common';
import { environment } from 'environments/environment';
import { HttpClient } from '@angular/common/http';
const _ = require('lodash');

export interface AuditLogData {
    userName: string,
    eventId: string,
    service: string,
    eventName: string,
    sourceIp: string,
    userRole: string,
    eventTime: string,
    endpointId: string,
    uriEndPoint: string,
    operation: string,
    resources: string
}

@Injectable()
export class AuditLogService {
    public baseUrl;

    private hcmReference = null;
    private _auditlogData$: ReplaySubject<AuditLogData[]>;
    // stores all auditlogData fetched from DB
    private dataStore: {
        auditlogData: AuditLogData[]
    }

    private devHmToken: string = null;
    private requestHeaders = null;
    private checkNotificationsPromise: Promise<any> = null;
    private loadLocalUpgradeDataInvoked: boolean = false;

    constructor(public http: HttpClient,private alert: VcaAlertsService) {
        const path = (window.location.pathname.match(/(.*)(\/auditlog-ui)(\/.*|$)/) || [])[1];
        this.baseUrl = !!path ? path + '/hcx-ui/rest' : '';
        if(environment.loadedInVCRemotePlugin) {
            this.baseUrl = HttpUtils.getBaseUrl();
        }
        this.devHmToken = this.findGetParameter('devHmToken');
        this.requestHeaders = new Headers();
        this.requestHeaders.append('Accept', 'application/json');
        this.requestHeaders.append('Content-Type', 'application/json');
        !!this.devHmToken && this.requestHeaders.append('x-hm-authorization', this.devHmToken);
        this.dataStore = { auditlogData: [] };
        this._auditlogData$ = <ReplaySubject<AuditLogData[]>>new ReplaySubject();
    }

    queryHcmInstances(successCb, errorCb) {
        let me = this;
        let hcmReferenceObservable = Observable.create(function (observer) {
            const path = (window.location.pathname.match(/(.*)(\/publisher-ui)(\/.*|$)/) || [])[1];
            if (!!path) {
                const url = !!path ? path + '/hcx-ui/rest/hybridity/api/metainfo/context/publisher' : '';
                me.http.get(url, {headers: me.requestHeaders})
                    .toPromise()
                    .then((data:any) => {
                        !!data && !!data.data && !!data.data.localEndpoints && data.data.localEndpoints.forEach(reference => observer.next(reference));
                        observer.complete();
                    }).catch(error => observer.error(error));
            } else {
                observer.complete();
            }
        });

        let subscription = hcmReferenceObservable.subscribe({
            next: reference => {
                // TODO: we should not capture only first vc, but should get data from all of them!
                if (!me.hcmReference && !!reference.hcsp && !!reference.hcsp.serverAddress) {
                    // retrofit structure (TODO: fix later)
                    reference.serverGuid = reference.resourceId;
                    reference.serverName = reference.resourceName;
                    me.hcmReference = reference;
                }
            },
            error: err => {
                setTimeout(() => !!subscription && subscription.unsubscribe(), 10);
                !!errorCb && errorCb();
            },
            complete: () => {
                setTimeout(() => !!subscription && subscription.unsubscribe(), 10);
                !!successCb && successCb();
            }
        });
    }

    get auditLogData() {
        return this._auditlogData$.asObservable();
    }


    private localSitesPromise: any = null;
    //public localResourceContainers: any = null;
    public localHcsp: any = null;
    getContext(force = false) {
        let me = this;
        if (!me.localSitesPromise || force) {
            me.localSitesPromise = me.http.get(me.baseUrl + "/hybridity/api/metainfo/context/auditlog", { headers: me.requestHeaders })
                .toPromise().then( (resp:any) => {
                    //me.localResourceContainers = [];
                    //let known_sites = {};
                    me.localHcsp = [];
                    let known_hcsp = {};
                    resp.data.localEndpoints.forEach(local_endpoint => {
                        if (local_endpoint.hcsp && local_endpoint.hcsp.uuid && !known_hcsp[local_endpoint.hcsp.uuid]) {
                            me.localHcsp.push(local_endpoint.hcsp);
                            local_endpoint.hcsp.resourceName = local_endpoint.resourceName; // XXX this is speculation
                            known_hcsp[local_endpoint.hcsp.uuid] = 1;
                        }
                        /*
                        let k = local_endpoint.endpointId + "|" + (local_endpoint.hcsp && local_endpoint.hcsp.uuid);
                        if (local_endpoint.hcsp && local_endpoint.hcsp.uuid && !known_sites[k]) {
                            me.localResourceContainers.push(local_endpoint);
                            known_sites[k] = 1;
                        }*/
                    });
                    return {'data': {'items': me.localHcsp}};
                });
        }
        return me.localSitesPromise;
    }

    loadAuditLogsData(siteInfo, param) {
        const me = this;

        const payload = {};
        if (param.searchContent) {
            payload['filter'] = {
                "fromDate": param.start,
                "toDate": param.end,
                "search": param.searchContent
            };
            payload['paging'] = {
                "offset": 1,
                "pageSize": 100
            };
            
        }
        else if ((param.start=="") &&(param.end=="")) {
            payload['filter'] = {
            };
            payload['paging'] = {
                "offset" : 1,
                "pageSize" : 100
            };
        }else {
            payload['filter'] = {
                "fromDate": param.start,
                "toDate": param.end
            };
            payload['paging'] = {
                "offset" : 1,
                "pageSize" : 100
            };
        }

        const wait_list = [];
        const local_audit_logs = [];
        const promise = me.getContext().then((contextResp) => {
           // let url = me.baseUrl + '/hybridity/api/auditLogs?action=query' + '&hcspUUID=' + (siteInfo.hcsp.hcspUUID || siteInfo.hcsp.uuid);
            let urlTag = '';
            if (siteInfo) {
                urlTag = '&hcspUUID=' + siteInfo.uuid;
            }
            const url = me.baseUrl + '/hybridity/api/auditLogs?action=query' + urlTag;
            return me.http.post(url, payload, { headers: me.requestHeaders })
                .toPromise()
                .then( (resp:any) => {
                    if (resp.events) {
                        const alData = [];
                        _.each(resp.events, function(item, i) {
                           alData[i] = {};
                           item._source = siteInfo;
                           item.userIdentities.length > 0 ? alData[i].userName = item.userIdentities[0].username : alData[i].userName = '';
                           item.eventId ? alData[i].eventId = item.eventId : alData[i].eventId = '';
                           item.eventName ? alData[i].eventName = item.eventName : alData[i].eventName = '';
                           item.service ? alData[i].service = item.service  : alData[i].service = '';
                           (item.restEndpoint && item.restEndpoint.sourceIPAddress) ? alData[i].sourceIp = item.restEndpoint.sourceIPAddress : alData[i].sourceIp = '';
                           // uri
                           (item.uriEndPoint && item.restEndpoint.uri) ? alData[i].uriEndPoint = item.restEndpoint.uri : alData[i].uriEndPoint = '';
                           (item.userIdentities && item.userIdentities.length > 0 && item.userIdentities[0].userRoles) ? alData[i].userRole = item.userIdentities[0].userRoles[0] : alData[i].userRole = '';
                           item.eventTime ? alData[i].eventTime = item.eventTime : alData[i].eventTime = '';
                        });

                        me.dataStore.auditlogData = alData;
                        me._auditlogData$.next(me.dataStore.auditlogData);
                    }
                    return resp;
                });
            });

        return promise;
    }

    public getAuditlogTimeLineForSystemAdmin() {
        const me = this;
        const payload = {};

        const url = me.baseUrl + '/hybridity/api/auditLogs?action=queryLogAvailability';
        const promise = me.http.post(url, payload, { headers: me.requestHeaders })
		    .toPromise()
		    .then( (resp) => {
                        return resp;
                    });

        return promise;
    }

    public getAuditlogTimeLineDuration(siteInfo) { // Request for start and end times for Auditlogs queries
        const me = this;
        const payload = {};

        const promise = me.getContext().then((contextResp) => {
            const url = me.baseUrl + '/hybridity/api/auditLogs?action=queryLogAvailability' + '&hcspUUID=' + siteInfo.uuid; // (siteInfo.hcsp.hcspUUID || siteInfo.hcsp.uuid);
            return me.http.post(url, payload, { headers: me.requestHeaders })
                .toPromise()
                .then( (resp) => {
                    return resp;
                });
            });

        return promise;

    }

    private findGetParameter(parameterName) {
        let result = null, tmp = [];
        location.search.substr(1).split('&').forEach(function(item) {
            tmp = item.split('=');
            if (tmp[0] === parameterName) { result = decodeURIComponent(tmp[1]); }
        });
        return result;
    }
    // In case we need the download link as a service
    public downLoadAuditlogArchive(siteInfo, startTime, endTime) {
        const me = this;
        const promise = me.getContext().then((contextResp) => {
            const url = me.baseUrl + '/hybridity/api/auditLogs/archive?fromDate=' + siteInfo + '&toDate=' + endTime + '&hcspUUID=' + siteInfo.uuid; // (siteInfo.hcsp.hcspUUID || siteInfo.hcsp.uuid);
            me.requestHeaders.append('Accept', 'application/octet-stream');
            return me.http.get(url, { headers: me.requestHeaders })
                .toPromise()
                .then((resp) => {
                    return resp;
                });
        });
        return promise;
    }

    // Simply returns download url to component request
    public getDownloadUrl(siteInfo, startTime, endTime) {
        const me = this;
        let urlTag = '';
        if (siteInfo) {
            urlTag = '&hcspUUID=' + siteInfo.uuid;
        }
        const url = me.baseUrl + '/hybridity/api/auditLogs/archive?fromDate=' + startTime + '&toDate=' + endTime + urlTag; // (siteInfo.hcsp.hcspUUID || siteInfo.hcsp.uuid);
        return url;
    }
}



// WEBPACK FOOTER //
// ./src/auditlog/src/auditlog-ui/auditlog.service.ts